import { FaArrowLeft, FaChevronLeft, FaPenToSquare, FaTrashCan } from "react-icons/fa6";

export const PopSplitterSection = ({ data, setCurrentLevel }) => {
  const sectionStyle = {
    background: "rgba(15, 23, 42, 0.5)",
    border: "1px solid rgba(51, 65, 85, 0.3)",
    backdropFilter: "blur(12px)",
  };

  return (
    <>
      <tr>
        <td colSpan={8} className="p-0">
          <div className="rounded-2xl overflow-hidden" style={sectionStyle}>
            <div
              className="flex items-center gap-3 px-5 py-4"
              style={{ borderBottom: "1px solid rgba(51, 65, 85, 0.2)" }}
            >
              <button
                onClick={() => setCurrentLevel("port")}
                className="flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-semibold text-slate-400 hover:text-cyan-400 hover:bg-slate-700/40 transition-all"
              >
                <FaChevronLeft className="text-[10px]" />
                Kembali
              </button>
              <h3 className="font-bold text-gray-100 uppercase tracking-tight text-sm">
                Manajemen Splitter
              </h3>
            </div>

            <div className="overflow-x-auto w-full">
              <table className="w-full text-sm">
                <thead>
                  <tr
                    style={{
                      background: "rgba(15, 23, 42, 0.7)",
                      borderBottom: "1px solid rgba(51, 65, 85, 0.3)",
                    }}
                  >
                    <th className="px-5 py-3.5 text-left text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      No
                    </th>
                    <th className="px-5 py-3.5 text-left text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      Port Input
                    </th>
                    <th className="px-5 py-3.5 text-left text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      Nama Splitter
                    </th>
                    <th className="px-5 py-3.5 text-center text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      Jumlah Port
                    </th>
                    <th className="px-5 py-3.5 text-center text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      Jumlah ODC
                    </th>
                    <th className="px-5 py-3.5 text-center text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      Jumlah ODP
                    </th>
                    <th className="px-5 py-3.5 text-center text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      Jumlah User
                    </th>
                    <th className="px-5 py-3.5 text-center text-[10px] font-bold text-slate-400 uppercase tracking-widest">
                      Aksi
                    </th>
                  </tr>
                </thead>

                <tbody
                  className="divide-y"
                  style={{ borderColor: "rgba(51, 65, 85, 0.15)" }}
                >
                  {data && data?.length > 0 ? (
                    data?.map((item, i) => (
                      <tr
                        key={i}
                        className="transition-colors duration-150"
                        style={{ background: "transparent" }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background =
                            "rgba(0, 180, 216, 0.04)";
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = "transparent";
                        }}
                      >
                        <td className="px-5 py-4 text-sm font-bold text-slate-500 font-mono">
                          {i + 1}
                        </td>
                        <td className="px-5 py-4 text-sm font-bold text-gray-100">
                          {item?.port ?? "Port 2"}
                        </td>
                        <td className="px-5 py-4 text-sm font-bold text-gray-100">
                          {item?.name}
                        </td>
                        <td className="px-5 py-4 text-sm font-medium text-slate-400 text-center">
                          {item?.total_port ?? "-"}
                        </td>
                        <td className="px-5 py-4 text-center">
                          <span className="text-xs font-semibold text-slate-400 bg-slate-700/30 px-2 py-1 rounded">
                            {item?.odcs?.length ?? 0}/4
                          </span>
                        </td>
                        <td className="px-5 py-4 text-center">
                          <span className="text-xs font-semibold text-slate-400 bg-slate-700/30 px-2 py-1 rounded">
                            {item?.odps?.length ?? 0}/16
                          </span>
                        </td>
                        <td className="px-5 py-4 text-center">
                          <span className="text-xs font-semibold text-cyan-400 bg-cyan-500/10 px-2 py-1 rounded" style={{ border: "1px solid rgba(0, 180, 216, 0.15)" }}>
                            {item?.user_pppoe ?? 0}/24
                          </span>
                        </td>
                        <td className="px-5 py-4">
                          <div className="flex justify-center gap-2">
                            <button
                              onClick={() => setCurrentLevel("odc")}
                              className="px-3 py-1.5 rounded-lg text-[10px] font-bold transition-all uppercase tracking-wider text-cyan-400 hover:text-white"
                              style={{
                                background: "rgba(0, 180, 216, 0.1)",
                                border: "1px solid rgba(0, 180, 216, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "rgba(0, 180, 216, 0.8)";
                                e.currentTarget.style.borderColor = "rgba(0, 180, 216, 0.8)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "rgba(0, 180, 216, 0.1)";
                                e.currentTarget.style.borderColor = "rgba(0, 180, 216, 0.2)";
                              }}
                            >
                              Buka Cabang
                            </button>
                            <button
                              className="p-1.5 rounded-lg text-amber-400 transition-all"
                              style={{
                                background: "rgba(245, 158, 11, 0.1)",
                                border: "1px solid rgba(245, 158, 11, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "rgba(245, 158, 11, 0.8)";
                                e.currentTarget.style.color = "#fff";
                                e.currentTarget.style.borderColor = "rgba(245, 158, 11, 0.8)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "rgba(245, 158, 11, 0.1)";
                                e.currentTarget.style.color = "#fbbf24";
                                e.currentTarget.style.borderColor = "rgba(245, 158, 11, 0.2)";
                              }}
                            >
                              <FaPenToSquare size={12} />
                            </button>
                            <button
                              className="p-1.5 rounded-lg text-red-400 transition-all"
                              style={{
                                background: "rgba(239, 68, 68, 0.1)",
                                border: "1px solid rgba(239, 68, 68, 0.2)",
                              }}
                              onMouseEnter={(e) => {
                                e.currentTarget.style.background = "rgba(239, 68, 68, 0.8)";
                                e.currentTarget.style.color = "#fff";
                                e.currentTarget.style.borderColor = "rgba(239, 68, 68, 0.8)";
                              }}
                              onMouseLeave={(e) => {
                                e.currentTarget.style.background = "rgba(239, 68, 68, 0.1)";
                                e.currentTarget.style.color = "#f87171";
                                e.currentTarget.style.borderColor = "rgba(239, 68, 68, 0.2)";
                              }}
                            >
                              <FaTrashCan size={12} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="px-5 py-12 text-center">
                        <p className="text-slate-500 text-sm">Tidak ada data splitter.</p>
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </td>
      </tr>
    </>
  );
};